<script setup lang="ts">
import { toRef } from 'vue';

import VButton from '@components/buttons/VButton/VButton.vue';
import { TRANSLATION_GROUP_NEW_APP_VERSION } from '@modules/new-app-version/constants';
import { useNewAppVersionStore } from '@modules/new-app-version/store';

const versionStore = useNewAppVersionStore();
const isNewVersionAvailable = toRef(versionStore, 'isNewVersionAvailable');
const { update } = versionStore;
</script>

<template>
  <VButton v-data-qa-auto-id="'NewAppVersion'"
    v-if="isNewVersionAvailable"
    :label="$getTranslation(TRANSLATION_GROUP_NEW_APP_VERSION, 'AVAILABLE_NEW_VERSION')"
    @click="update"
  />
</template>
